"use client"
import { useState, useEffect } from "react"
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Container,
  Avatar,
  BottomNavigation,
  BottomNavigationAction,
  Card,
  CardContent,
  TextField,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Grid,
  Chip,
  Stack,
  Fab,
  Checkbox,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
  Tab,
  Tabs,
  Paper,
  ListItemButton,
} from "@mui/material"
import {
  Payment as PaymentIcon,
  Home as HomeIcon,
  CalendarToday as CalendarTodayIcon,
  Notifications as NotificationsIcon,
  AccountCircle as AccountCircleIcon,
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Vaccines as VaccinesIcon,
  Pets as PetsIcon,
  LocalHospital as LocalHospitalIcon,
  Send as SendIcon,
  People as PeopleIcon,
} from "@mui/icons-material"
import { useNavigate } from "react-router-dom"
import { toast, ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import ExitToAppIcon from "@mui/icons-material/ExitToApp"
import axios from "axios"

const AdminVaccinsChevaux = () => {
  const navigate = useNavigate()
  const [vaccines, setVaccines] = useState([])
  const [users, setUsers] = useState([])
  const [searchQuery, setSearchQuery] = useState("")
  const [openAddModal, setOpenAddModal] = useState(false)
  const [openEditModal, setOpenEditModal] = useState(false)
  const [openSendModal, setOpenSendModal] = useState(false)
  const [selectedVaccine, setSelectedVaccine] = useState(null)
  const [selectedUsers, setSelectedUsers] = useState([])
  const [selectedVaccineForSend, setSelectedVaccineForSend] = useState("")
  const [loading, setLoading] = useState(false)
  const [tabValue, setTabValue] = useState(0)
  const [newVaccine, setNewVaccine] = useState({
    name: "",
    price: "",
  })

  const token = localStorage.getItem("CC_Token")
  const baseUrl = process.env.REACT_APP_APP_URL

  useEffect(() => {
    fetchVaccines()
    fetchUsers()
  }, [token, baseUrl])

  const fetchVaccines = async () => {
    setLoading(true)
    try {
      const response = await axios.get(`${baseUrl}/api/vaccins`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      setVaccines(response.data)
    } catch (error) {
      console.error("Error fetching vaccines:", error)
      toast.error("Erreur lors de la récupération des vaccins.", {
        position: "top-right",
        autoClose: 3000,
      })
    } finally {
      setLoading(false)
    }
  }

  const handleUsersSelection = (userId) => {
  console.log('handleUserSelection called with userId:', userId);
  console.log('Current selectedUsers before:', selectedUsers);
  
  setSelectedUsers(prev => {
    console.log('Previous selectedUsers:', prev);
    if (prev.includes(userId)) {
      const newUsers = prev.filter(id => id !== userId);
      console.log('Removing user, new array:', newUsers);
      return newUsers;
    } else {
      const newUsers = [...prev, userId];
      console.log('Adding user, new array:', newUsers);
      return newUsers;
    }
  })
}

  const fetchUsers = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/users`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      setUsers(response.data)
    } catch (error) {
      console.error("Error fetching users:", error)
      toast.error("Erreur lors de la récupération des utilisateurs.", {
        position: "top-right",
        autoClose: 3000,
      })
    }
  }

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value)
  }

  const handleNavigateToNotifications = () => {
    navigate("/AdminGetNotifs")
  }

  const handleLogout = () => {
    localStorage.removeItem("CC_Token")
    localStorage.removeItem("user")
    toast.success("Vous avez été déconnecté avec succès.", {
      position: "top-right",
      autoClose: 3000,
    })
    setTimeout(() => navigate("/login"), 4000)
  }

  const handleProfile = () => {
    navigate("/ProfileAdmin")
  }

  const handleOpenAddModal = () => {
    setNewVaccine({
      name: "",
      price: "",
    })
    setOpenAddModal(true)
  }

  const handleCloseAddModal = () => {
    setOpenAddModal(false)
    setNewVaccine({
      name: "",
      price: "",
    })
  }

  const handleOpenEditModal = (vaccine) => {
    setSelectedVaccine(vaccine)
    setOpenEditModal(true)
  }

  const handleCloseEditModal = () => {
    setOpenEditModal(false)
    setSelectedVaccine(null)
  }

  const handleOpenSendModal = () => {
    setSelectedUsers([])
    setSelectedVaccineForSend("")
    setOpenSendModal(true)
  }

  const handleCloseSendModal = () => {
    setOpenSendModal(false)
    setSelectedUsers([])
    setSelectedVaccineForSend("")
  }

  const handleAddVaccine = async () => {
    if (!newVaccine.name || !newVaccine.price) {
      toast.error("Veuillez remplir tous les champs obligatoires.", {
        position: "top-right",
        autoClose: 3000,
      })
      return
    }

    setLoading(true)
    try {
      const response = await axios.post(`${baseUrl}/api/vaccins`, {
        vaccin_name: newVaccine.name,
        vaccin_prix: newVaccine.price,
        vaccin_date: new Date().toISOString().split("T")[0],
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

      toast.success("Vaccin ajouté avec succès.", {
        position: "top-right",
        autoClose: 3000,
      })

      // Refresh the vaccines list
      await fetchVaccines()
      handleCloseAddModal()
    } catch (error) {
      console.error("Error adding vaccine:", error)
      toast.error("Erreur lors de l'ajout du vaccin.", {
        position: "top-right",
        autoClose: 3000,
      })
    } finally {
      setLoading(false)
    }
  }

  const handleEditVaccine = async () => {
    if (!selectedVaccine.vaccin_name || !selectedVaccine.vaccin_prix) {
      toast.error("Veuillez remplir tous les champs obligatoires.", {
        position: "top-right",
        autoClose: 3000,
      })
      return
    }

    setLoading(true)
    try {
      const response = await axios.put(`${baseUrl}/api/vaccins/${selectedVaccine.id}`, selectedVaccine, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

      toast.success("Vaccin modifié avec succès.", {
        position: "top-right",
        autoClose: 3000,
      })

      // Refresh the vaccines list
      await fetchVaccines()
      handleCloseEditModal()
    } catch (error) {
      console.error("Error updating vaccine:", error)
      toast.error("Erreur lors de la modification du vaccin.", {
        position: "top-right",
        autoClose: 3000,
      })
    } finally {
      setLoading(false)
    }
  }

  const handleDeleteVaccine = async (vaccineId) => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer ce vaccin ?")) {
      setLoading(true)
      try {
        await axios.delete(`${baseUrl}/api/vaccins/${vaccineId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })

        toast.success("Vaccin supprimé avec succès.", {
          position: "top-right",
          autoClose: 3000,
        })

        // Refresh the vaccines list
        await fetchVaccines()
      } catch (error) {
        console.error("Error deleting vaccine:", error)
        toast.error("Erreur lors de la suppression du vaccin.", {
          position: "top-right",
          autoClose: 3000,
        })
      } finally {
        setLoading(false)
      }
    }
  }

  const handleUserSelection = (userId) => {
    setSelectedUsers(prev => {
      if (prev.includes(userId)) {
        return prev.filter(id => id !== userId)
      } else {
        return [...prev, userId]
      }
    })
  }

  const handleSendVaccineToUsers = async () => {
    if (selectedUsers.length === 0 || !selectedVaccineForSend) {
      toast.error("Veuillez sélectionner au moins un utilisateur et un vaccin.", {
        position: "top-right",
        autoClose: 3000,
      })
      return
    }

    setLoading(true)
    try {
      const response = await axios.post(`${baseUrl}/api/vaccins/storePaymentVaccin`, {
        user_ids: selectedUsers,
        vaccin_id: selectedVaccineForSend,
        withoutInvoice: true
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

      toast.success(`Vaccin envoyé avec succès à ${selectedUsers.length} utilisateur(s).`, {
        position: "top-right",
        autoClose: 3000,
      })

      handleCloseSendModal()
    } catch (error) {
      console.error("Error sending vaccine to users:", error)
      toast.error("Erreur lors de l'envoi du vaccin.", {
        position: "top-right",
        autoClose: 3000,
      })
    } finally {
      setLoading(false)
    }
  }

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue)
  }

  // Filter vaccines based on search query
  const filteredVaccines = vaccines.filter((vaccine) => {
    const lowercasedQuery = searchQuery.toLowerCase()
    return (
      (vaccine.vaccin_name && vaccine.vaccin_name.toLowerCase().includes(lowercasedQuery)) ||
      (vaccine.vaccin_prix && vaccine.vaccin_prix.toString().includes(lowercasedQuery))
    )
  })

  // Filter users based on search query
  const filteredUsers = users.filter((user) => {
    const lowercasedQuery = searchQuery.toLowerCase()
    return (
      (user.name && user.name.toLowerCase().includes(lowercasedQuery)) ||
      (user.email && user.email.toLowerCase().includes(lowercasedQuery))
    )
  })

  return (
    <div className="app">
      {/* Toast Container */}
      <ToastContainer />

      {/* Header */}
      <AppBar position="fixed" sx={{ backgroundColor: "#003366" }}>
        <Toolbar>
          <Avatar alt="Logo" src={"../assets/cej.png"} sx={{ width: 40, height: 40, marginRight: "0.5rem" }} />
          <Typography
            variant="h6"
            sx={{
              flexGrow: 1,
              fontSize: { xs: "1rem", sm: "1.25rem" },
              color: "#ffffff",
            }}
          >
            Gestion des Vaccins - Chevaux
          </Typography>
          <IconButton color="inherit" onClick={handleNavigateToNotifications}>
            <NotificationsIcon />
          </IconButton>
          <IconButton color="inherit" onClick={handleProfile}>
            <AccountCircleIcon />
          </IconButton>
          <IconButton color="inherit" onClick={handleLogout}>
            <ExitToAppIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Main Content */}
      <Box
        sx={{
          padding: "1rem",
          paddingTop: "90px", // Space for header
          paddingBottom: "70px", // Space for footer
          backgroundColor: "#f5f5f5",
          minHeight: "100vh",
        }}
      >
        <Container maxWidth="sm">
          {/* Tabs */}
          <Paper sx={{ mb: 3 }}>
            <Tabs value={tabValue} onChange={handleTabChange} centered>
              <Tab label="Vaccins" icon={<VaccinesIcon />} />
              <Tab label="Envoi Groupé" icon={<SendIcon />} />
            </Tabs>
          </Paper>

          {/* Tab Panel 0 - Vaccines */}
          {tabValue === 0 && (
            <>
              {/* Statistics Card */}
              <Card sx={{ boxShadow: 3, borderRadius: 2, mb: 3 }}>
                <CardContent>
                  <Typography variant="h6" sx={{ mb: 2, color: "#003366", fontWeight: "bold", textAlign: "center" }}>
                    Statistiques des Vaccins
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Box sx={{ textAlign: "center", p: 1, bgcolor: "#e3f2fd", borderRadius: 1 }}>
                        <Typography variant="body2" sx={{ color: "#666" }}>
                          Total
                        </Typography>
                        <Typography variant="h6" sx={{ fontWeight: "bold", color: "#003366" }}>
                          {vaccines.length}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={6}>
                      <Box sx={{ textAlign: "center", p: 1, bgcolor: "#e8f5e8", borderRadius: 1 }}>
                        <Typography variant="body2" sx={{ color: "#666" }}>
                          Prix Moyen
                        </Typography>
                        <Typography variant="h6" sx={{ fontWeight: "bold", color: "#4CAF50" }}>
                          {vaccines.length > 0 
                            ? `${(vaccines.filter((v) => v.vaccin_prix && !isNaN(Number.parseFloat(v.vaccin_prix))).reduce((sum, v) => sum + Number.parseFloat(v.vaccin_prix), 0) / (vaccines.filter((v) => v.vaccin_prix && !isNaN(Number.parseFloat(v.vaccin_prix))).length || 1)).toFixed(2)} TND`
                            : "0 TND"
                          }
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>

              {/* Main Vaccines Section */}
              <Card sx={{ boxShadow: 3, borderRadius: 2 }}>
                <CardContent>
                  <Typography
                    variant="h5"
                    sx={{ marginBottom: "1.5rem", textAlign: "center", color: "#003366", fontWeight: "bold" }}
                  >
                    Liste des Vaccins
                  </Typography>

                  {/* Search Bar */}
                  <TextField
                    label="Rechercher un vaccin"
                    variant="outlined"
                    fullWidth
                    value={searchQuery}
                    onChange={handleSearchChange}
                    sx={{ marginBottom: "1rem" }}
                    InputProps={{
                      startAdornment: <VaccinesIcon sx={{ mr: 1, color: "#666" }} />,
                    }}
                  />

                  {/* Vaccines List */}
                  <Stack spacing={2}>
                    {filteredVaccines.map((vaccine) => (
                      <Card
                        key={vaccine.id}
                        sx={{
                          border: "1px solid #e0e0e0",
                          "&:hover": {
                            boxShadow: 4,
                            backgroundColor: "#f8f9fa",
                          },
                        }}
                      >
                        <CardContent sx={{ pb: 1 }}>
                          {/* Vaccine Header */}
                          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                            <Avatar sx={{ bgcolor: "#003366", mr: 2 }}>
                              <LocalHospitalIcon />
                            </Avatar>
                            <Box sx={{ flexGrow: 1 }}>
                              <Typography variant="h6" sx={{ fontWeight: "bold", color: "#003366" }}>
                                {vaccine.vaccin_name || "Nom non défini"}
                              </Typography>
                              <Typography variant="body2" sx={{ color: "#666" }}>
                                Prix: {vaccine.vaccin_prix ? `${vaccine.vaccin_prix} TND` : "Prix non défini"}
                              </Typography>
                            </Box>
                          </Box>

                          {/* Action Buttons */}
                          <Stack direction="row" spacing={1}>
                            <Button
                              variant="outlined"
                              size="small"
                              fullWidth
                              startIcon={<EditIcon />}
                              onClick={() => handleOpenEditModal(vaccine)}
                            >
                              Modifier
                            </Button>
                            <Button
                              variant="outlined"
                              color="error"
                              size="small"
                              fullWidth
                              startIcon={<DeleteIcon />}
                              onClick={() => handleDeleteVaccine(vaccine.id)}
                              disabled={loading}
                            >
                              Supprimer
                            </Button>
                          </Stack>
                        </CardContent>
                      </Card>
                    ))}

                    {filteredVaccines.length === 0 && (
                      <Box sx={{ textAlign: "center", py: 4 }}>
                        <PetsIcon sx={{ fontSize: 64, color: "#ccc", mb: 2 }} />
                        <Typography variant="h6" sx={{ color: "#666" }}>
                          Aucun vaccin trouvé
                        </Typography>
                        <Typography variant="body2" sx={{ color: "#999" }}>
                          {searchQuery ? "Essayez de modifier votre recherche" : "Commencez par ajouter un vaccin"}
                        </Typography>
                      </Box>
                    )}
                  </Stack>
                </CardContent>
              </Card>
            </>
          )}

          {/* Tab Panel 1 - Send to Users */}
          {tabValue === 1 && (
            <Card sx={{ boxShadow: 3, borderRadius: 2 }}>
              <CardContent>
                <Typography
                  variant="h5"
                  sx={{ marginBottom: "1.5rem", textAlign: "center", color: "#003366", fontWeight: "bold" }}
                >
                  Envoi Groupé de Vaccins
                </Typography>

                <Button
                  variant="contained"
                  fullWidth
                  startIcon={<SendIcon />}
                  onClick={handleOpenSendModal}
                  sx={{
                    backgroundColor: "#003366",
                    "&:hover": {
                      backgroundColor: "#002244",
                    },
                    mb: 2,
                  }}
                >
                  Envoyer un Vaccin à Plusieurs Utilisateurs
                </Button>

                <Typography variant="body2" sx={{ color: "#666", textAlign: "center" }}>
                  Sélectionnez plusieurs utilisateurs et envoyez-leur un vaccin sans générer de facture.
                </Typography>
              </CardContent>
            </Card>
          )}
        </Container>
      </Box>

      {/* Floating Action Button - Only show on vaccines tab */}
      {tabValue === 0 && (
        <Fab
          color="primary"
          aria-label="add"
          sx={{
            position: "fixed",
            bottom: 80,
            right: 16,
            backgroundColor: "#003366",
            "&:hover": {
              backgroundColor: "#002244",
            },
          }}
          onClick={handleOpenAddModal}
        >
          <AddIcon />
        </Fab>
      )}

      {/* Footer */}
      <Box sx={{ position: "fixed", bottom: 0, width: "100%" }}>
        <BottomNavigation
          sx={{
            backgroundColor: "#003366",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <BottomNavigationAction
            label="Calendrier"
            icon={<CalendarTodayIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
            sx={{ color: "#ffffff", minWidth: "auto" }}
            onClick={() => navigate("/AdminChrono")}
          />
          <BottomNavigationAction
            label="Home"
            icon={<HomeIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
            sx={{ color: "#ffffff", minWidth: "auto" }}
            onClick={() => navigate("/Admin")}
          />
          <BottomNavigationAction
            label="Paiement"
            icon={<PaymentIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
            sx={{ color: "#ffffff", minWidth: "auto" }}
            onClick={() => navigate("/AdminPaiment")}
          />
        </BottomNavigation>
      </Box>

      {/* Add Vaccine Modal - Simplified */}
      <Dialog open={openAddModal} onClose={handleCloseAddModal} fullWidth maxWidth="sm">
        <DialogTitle sx={{ color: "#003366", fontWeight: "bold" }}>Ajouter un Nouveau Vaccin</DialogTitle>
        <DialogContent>
          <TextField
            label="Nom du Vaccin *"
            value={newVaccine.name}
            onChange={(e) => setNewVaccine({ ...newVaccine, name: e.target.value })}
            fullWidth
            margin="normal"
            required
          />

          <TextField
            label="Prix (TND) *"
            type="number"
            value={newVaccine.price}
            onChange={(e) => setNewVaccine({ ...newVaccine, price: e.target.value })}
            fullWidth
            margin="normal"
            required
            inputProps={{ min: 0, step: 0.01 }}
          />
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handleCloseAddModal} color="inherit">
            Annuler
          </Button>
          <Button
            onClick={handleAddVaccine}
            color="primary"
            variant="contained"
            disabled={loading}
            sx={{
              backgroundColor: "#003366",
              "&:hover": {
                backgroundColor: "#002244",
              },
            }}
          >
            Ajouter
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Vaccine Modal - Simplified */}
      {selectedVaccine && (
        <Dialog open={openEditModal} onClose={handleCloseEditModal} fullWidth maxWidth="sm">
          <DialogTitle sx={{ color: "#003366", fontWeight: "bold" }}>Modifier le Vaccin</DialogTitle>
          <DialogContent>
            <TextField
              label="Nom du Vaccin *"
              value={selectedVaccine.vaccin_name}
              onChange={(e) => setSelectedVaccine({ ...selectedVaccine, vaccin_name: e.target.value })}
              fullWidth
              margin="normal"
              required
            />

            <TextField
              label="Prix (TND) *"
              type="number"
              value={selectedVaccine.vaccin_prix || ""}
              onChange={(e) => setSelectedVaccine({ ...selectedVaccine, vaccin_prix: e.target.value })}
              fullWidth
              margin="normal"
              required
              inputProps={{ min: 0, step: 0.01 }}
            />
          </DialogContent>
          <DialogActions sx={{ p: 2 }}>
            <Button onClick={handleCloseEditModal} color="inherit">
              Annuler
            </Button>
            <Button
              onClick={handleEditVaccine}
              color="primary"
              variant="contained"
              disabled={loading}
              sx={{
                backgroundColor: "#003366",
                "&:hover": {
                  backgroundColor: "#002244",
                },
              }}
            >
              Sauvegarder
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Send Vaccine to Users Modal */}
      <Dialog open={openSendModal} onClose={handleCloseSendModal} fullWidth maxWidth="md">
        <DialogTitle sx={{ color: "#003366", fontWeight: "bold" }}>
          Envoyer un Vaccin à Plusieurs Utilisateurs
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            {/* Vaccine Selection */}
            <Grid item xs={12}>
              <FormControl fullWidth margin="normal" required>
                <InputLabel>Sélectionner un Vaccin</InputLabel>
                <Select
                  value={selectedVaccineForSend}
                  onChange={(e) => setSelectedVaccineForSend(e.target.value)}
                  label="Sélectionner un Vaccin"
                >
                  {vaccines.map((vaccine) => (
                    <MenuItem key={vaccine.id} value={vaccine.id}>
                      {vaccine.vaccin_name} - {vaccine.vaccin_prix} TND
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Users Selection */}
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ mb: 2, color: "#003366" }}>
                Sélectionner les Utilisateurs ({selectedUsers.length} sélectionné(s))
              </Typography>
              
              <TextField
                label="Rechercher un utilisateur"
                variant="outlined"
                fullWidth
                value={searchQuery}
                onChange={handleSearchChange}
                sx={{ mb: 2 }}
                InputProps={{
                  startAdornment: <PeopleIcon sx={{ mr: 1, color: "#666" }} />,
                }}
              />

              <Paper sx={{ maxHeight: 300, overflow: 'auto' }}>
                <List>
                  {filteredUsers.map((user, index) => (
                    <div key={user.id}>
  <ListItemButton
  onClick={() => handleUsersSelection(user.id)}
  sx={{
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
    backgroundColor: selectedUsers.includes(user.id) ? "#e8f5e8" : "transparent",
  }}
>
  <ListItemIcon>
    {selectedUsers.includes(user.id) ? (
      <Box
        sx={{
          width: 24,
          height: 24,
          borderRadius: "50%",
          backgroundColor: "#4CAF50",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          fontSize: "16px",
          fontWeight: "bold",
        }}
      >
        ✓
      </Box>
    ) : (
      <Box
        sx={{
          width: 24,
          height: 24,
          borderRadius: "50%",
          border: "2px solid #ccc",
        }}
      />
    )}
  </ListItemIcon>
  <ListItemText
    primary={user.name || user.email}
    secondary={user.email}
  />
</ListItemButton>
  {index < filteredUsers.length - 1 && <Divider />}
</div>
                  ))}
                </List>
              </Paper>

              {filteredUsers.length === 0 && (
                <Box sx={{ textAlign: "center", py: 4 }}>
                  <PeopleIcon sx={{ fontSize: 64, color: "#ccc", mb: 2 }} />
                  <Typography variant="h6" sx={{ color: "#666" }}>
                    Aucun utilisateur trouvé
                  </Typography>
                </Box>
              )}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handleCloseSendModal} color="inherit">
            Annuler
          </Button>
          <Button
            onClick={handleSendVaccineToUsers}
            color="primary"
            variant="contained"
            disabled={loading || selectedUsers.length === 0 || !selectedVaccineForSend}
            sx={{
              backgroundColor: "#003366",
              "&:hover": {
                backgroundColor: "#002244",
              },
            }}
          >
            Envoyer ({selectedUsers.length})
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default AdminVaccinsChevaux
